import Home from "./HomeStatic/Home_new"
//import Home from "./Home_old"
export default Home;